import type { TranslationTree } from '../../types';

export const administration: TranslationTree = {
  administration: {
    tabs: { members: 'Mitglieder', companies: 'Unternehmen' },
    retry: 'Erneut versuchen',
    roles: { user: 'Benutzer', admin: 'Administrator', superAdmin: 'Super-Admin' },
    errors: {
      generic: 'Etwas ist schiefgelaufen. Bitte erneut versuchen.',
    },
    members: {
      search: 'Nach E-Mail oder Name suchen…',
      roleFilter: 'Nach Rolle filtern',
      companyFilter: 'Nach Unternehmen filtern',
      allRoles: 'Alle Rollen',
      allCompanies: 'Alle Unternehmen',
      colMember: 'Mitglied',
      colRole: 'Rolle',
      colCompany: 'Unternehmen',
      colAccess: 'Zugriff',
      colLastLogin: 'Letzte Anmeldung',
      colActions: 'Aktionen',
      empty: 'Noch keine Mitglieder — fügen Sie das erste hinzu.',
      you: 'Sie',
      noModules: 'Keine Module',
      actions: 'Mitgliedsaktionen öffnen',
      locked: 'Geschütztes Konto',
      lockedSuper: 'Super-Admin-Konten werden über die CLI verwaltet — geschützt',
      lockedScope: 'Wird von einem Super-Admin verwaltet',
    },
    member: {
      addTitle: 'Mitglied hinzufügen',
      addSubtitle: 'Erstellen Sie ein neues Konto für diese Instanz.',
      editTitle: 'Mitglied bearbeiten',
      add: 'Mitglied hinzufügen',
      save: 'Änderungen speichern',
      edit: 'Bearbeiten',
      resetPassword: 'Passwort zurücksetzen',
      delete: 'Löschen',
      email: 'E-Mail',
      password: 'Passwort',
      firstName: 'Vorname',
      lastName: 'Nachname',
      role: 'Rolle',
      roleHint: 'Super-Admin wird über die CLI verwaltet und kann hier nicht gesetzt werden.',
      company: 'Unternehmen',
      access: 'Modulzugriff',
      deleteTitle: 'Mitglied löschen',
      deleteBody:
        'Dies entfernt {{email}} und die Zugriffe dauerhaft. Dies kann nicht rückgängig gemacht werden.',
      confirmDelete: 'Mitglied löschen',
    },
    reset: {
      title: 'Passwort zurücksetzen',
      body: 'Legen Sie ein neues Passwort für {{email}} fest.',
      newPassword: 'Neues Passwort',
      confirm: 'Passwort zurücksetzen',
    },
    companies: {
      search: 'Unternehmen suchen…',
      new: 'Neues Unternehmen',
      empty: 'Noch keine Unternehmen — erstellen Sie das erste.',
      colCompany: 'Unternehmen',
      colMembers: 'Mitglieder',
      colActions: 'Aktionen',
      members: '{{count}} Mitglieder',
      rename: 'Umbenennen',
      delete: 'Löschen',
    },
    company: {
      createTitle: 'Neues Unternehmen',
      renameTitle: 'Unternehmen umbenennen',
      name: 'Unternehmensname',
      create: 'Unternehmen erstellen',
      save: 'Änderungen speichern',
      deleteTitle: '„{{name}}“ löschen',
      deleteBody:
        'Dieses Unternehmen hat {{count}} Mitglieder. Wählen Sie, was mit ihnen geschieht.',
      reassignOption: 'Mitglieder neu zuweisen, dann löschen',
      reassignDesc:
        'Verschieben Sie alle Mitglieder in ein anderes Unternehmen und löschen Sie dann dieses.',
      reassignTarget: 'Mitglieder verschieben nach',
      cascadeOption: 'Unternehmen und Mitglieder löschen',
      cascadeDesc:
        'Entfernt dieses Unternehmen und alle Mitgliedskonten dauerhaft. Nicht umkehrbar.',
      warning:
        'Super-Admin-Konten und Ihr eigenes Konto werden nie gelöscht — der Server blockiert das. Hielt dieses Unternehmen eines, wird das kaskadierte Löschen abgelehnt.',
      reassignConfirm: 'Neu zuweisen & löschen',
      cascadeConfirm: 'Alles löschen',
    },
  },
};
